import { OnboardingBenefitsStep } from "@/blocks/OnboardingBenefitsStep";
import { OnboardingIntroStep } from "@/blocks/OnboardingIntroStep";
import { OnboardingNextStepsStep } from "@/blocks/OnboardingNextStepsStep";

import { OnboardingVariantType } from "../types";

export const noConcernsStepVariant: OnboardingVariantType = {
  steps: [
    { Component: OnboardingIntroStep },
    { Component: OnboardingBenefitsStep },
    { Component: OnboardingNextStepsStep },
  ],
};
